/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum I_INVESTOR_TRANSACTION_TYPE_ENUM {
  Deposit = 'deposit',
  Withdrawal = 'withdrawal',
  Investment = 'investment',
}

export enum I_USER_TYPE_ENUM {
  Investor = 'investor',
  Owner = 'owner',
}

export enum I_OWNER_ESTATE_TYPE_ENUM {
  House = 'house',
  Flat = 'flat',
}

/** The current status of the estate. */
export enum I_OWNER_ESTATE_STATUS {
  Novostavba = 'Novostavba',
  PovodnyStav = 'Pôvodný stav',
  PoKompletnejRekonstrukcii = 'Po kompletnej rekonštrukcii',
  PoCiastocnejRekonstrukcii = 'Po čiastočnej rekonštrukcii',
  PrebiehaRekonstrukcia = 'Prebieha rekonštrukcia',
  VoVystavbeNeskolaudovane = 'Vo výstavbe, neskolaudované',
}

export interface IAudit {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  type: string
  last: object
  list: object
  overrides: object
}

export interface IOwnerEstate {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  /** @example "house" */
  type: I_OWNER_ESTATE_TYPE_ENUM
  address: string
  x: number
  y: number
  level: number
  flatNumber: string
  flatArea: number
  houseUsableArea: number
  landArea: number
  numberOfFloors: number
  /**
   * The current status of the estate.
   * @example "Novostavba"
   */
  status: I_OWNER_ESTATE_STATUS
  numberOfRooms: number
  numberOfRestrooms: number
  numberOfBathrooms: number
  numberOfParkingSpots: number
  numberOfGarageSpots: number
  apiEstimatedValue: number
  ownerEstimatedValue: number
  userId: string
  _user?: IUserBase
  _ownerPensionOrder?: IOwnerPensionOrder
  _audit?: IAudit
}

export interface IUpload {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  /** @format uuid */
  key: string
  name: string
  filePath: string
  estateId: string
  ownerPensionOrderId: string
  _user?: IUserBase
  _estate?: IOwnerEstate
  _ownerPensionOrder?: IOwnerPensionOrder
  _audit?: IAudit
}

export interface IOwnerPensionOrder {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  userId: string
  payoutYears: number
  isLifeTime: boolean
  isVerified: boolean
  monthlyPensionValue: number
  estateId: string
  _estate?: IOwnerEstate
  _uploads?: IUpload[]
  _user?: IUserBase
  _audit?: IAudit
}

export interface IPersonalInformationAddress {
  street: string
  city: string
  postalCode: string
  country: string
}

export interface IPersonalInformation {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  step: number | null
  maxStep: number | null
  maxStepHint: string | null
  firstName: string | null
  lastName: string | null
  age: number | null
  address: IPersonalInformationAddress | null
  biometricConsent: boolean
  isVerified: boolean
  isConfirmed: boolean
  confirmationStatus:
    | 'pending'
    | 'user_ok'
    | 'user_nok'
    | 'admin_ok'
    | 'admin_rejected'
    | 'admin_canceled'
  hasIncorrectData: boolean
  isPoliticallyExposed: boolean
  isSanctionedPerson: boolean
  /** @format date-time */
  biometricConsentAgreedAt?: string
  /** @format date-time */
  verifiedAt?: string
  /** @format date-time */
  confirmedAt?: string
  userId: string
  /** @default null */
  _fullName: string
}

export interface IVeriffDocument {
  number: string
}

export interface IIdCardVerification {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  sessionId: string
  sessionUrl: string
  status: string
  host: string | null
  metadata: object | null
  lastEvent: string | null
  eventsHistory: string
  statusHistory: string
  /** @format date-time */
  decisionTime: string | null
  person: object | null
  document: IVeriffDocument | null
  personalInformationId: string
  _user?: IUserBase
}

export interface IUserBase {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  sid: string
  email: string | null
  /** @default false */
  isEmailVerified: boolean
  phoneNumber: string
  /** @default true */
  dataProcessingConsent: boolean
  /** @default false */
  isPhoneNumberVerified: boolean
  /** @default false */
  hasPassword: boolean
  /** @default false */
  isGoogleAccount: boolean
  /** @format date-time */
  registeredAt: string | null
  testing: boolean
  investorProfileId: string | null
  ownerProfileId: string | null
  personalInformationId: string | null
  signaturePrivateKey: string | null
  isInvestor: I_USER_TYPE_ENUM
  /** @default false */
  isOwner: boolean
  _ownerPensionOrder?: IOwnerPensionOrder
  _personalInformation?: IPersonalInformation
  _idCardVerifications?: IIdCardVerification[]
  _audit?: IAudit
}

export interface IAdminUser {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  email: string
  firstName: string
  lastName: string
  fullName: string | null
  role: 'moderator' | 'developer'
  isSuperAdmin: boolean
}

export interface IInvestorTransaction {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  amount: number
  /** @example "deposit" */
  type: I_INVESTOR_TRANSACTION_TYPE_ENUM
  recipientIBAN?: string
  senderIBAN?: string
  investorProfileId: string
  userId: string
  adminUserId?: string
  investmentOrderId?: string
  _user?: IUserBase
  _adminUser?: IAdminUser
}

export interface IGetInvestorTransactionsAndCountResponse {
  /** success message */
  success: string
  data: IInvestorTransaction[]
  total: number
}

export interface ICreateUserInvestorTransactionResponse {
  /** success message */
  success: string
  investorTransaction: IInvestorTransaction
}

export interface ITransactionSnapshot {
  /** Running balance after this transaction */
  balance: number
  /** Type of transaction */
  type: 'deposit' | 'withdrawal' | 'investment'
  /**
   * When the transaction occurred
   * @format date-time
   */
  createdAt: string
}

export interface IGetInvestorBalanceSnapshotsResponse {
  /** success message */
  success: string
  /** Array of balance snapshots over time */
  snapshots: ITransactionSnapshot[]
}

export interface IInvestmentProductSnapshot {
  id: string
  name: string
  slug: string
  interestPerAnnum: number
  idx: number
  description?: string
  payoutFrequency?: string
  durationInMonths?: number
  bonus?: number
}

export type IContractSignature = object

export interface IContract {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  type: 'investor_main' | 'investor_investment_order'
  title: string
  content: string
  productSnapshot: IInvestmentProductSnapshot
  investmentProductId: string
  userId: object
  replacements: object
  contractTemplateId: string
  investmentOrderId: string
  signature: IContractSignature
}

export interface IInvestorWallet {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  /** @default 0 */
  funds: number
  userId: string
  investorProfileId: string
  _fundTransactions?: IInvestorTransaction[]
}

export interface IInvestorProfile {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  variableSymbol: string | null
  investorContractId: string | null
  investorWalletId: string | null
  userId: string
  _user?: IUserBase
  _investorContract?: IContract
  _investorWallet?: IInvestorWallet
  _audit?: IAudit
  _investmentOrdersCount: number
}

export interface IOwnerProfile {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  userId: string
  _user?: IUserBase
  _audit?: IAudit
}

export enum I_SMS_VERIFICATION_TYPE_ENUM {
  UserRegistration = 'userRegistration',
  UserLogin = 'userLogin',
  UserReverification = 'userReverification',
  InvestorContract = 'investorContract',
}

export enum I_SMS_VERIFICATION_STATUS_ENUM {
  Unsent = 'unsent',
  Error = 'error',
  Sent = 'sent',
  Expired = 'expired',
  Verified = 'verified',
  Failed = 'failed',
  Cancelled = 'cancelled',
}

export enum IContractTypeEnum {
  InvestorMain = 'investor_main',
  InvestorInvestmentOrder = 'investor_investment_order',
}

export interface IInvestorContractInvestmentOrderInput {
  hasOneTimeInvestment: boolean
  oneTimeInvestmentAmount: number
  hasMonthlyInvestment: boolean
  monthlyInvestmentAmount?: number
  investmentProductId: string
  riskAcknowledged: boolean
  durationInMonths: number
}

export interface IInvestorContractDataItem {
  /** @example "investor_main" */
  contractType: IContractTypeEnum
  investmentOrder?: IInvestorContractInvestmentOrderInput
}

export interface ISmsVerification {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  recipientNumber: string
  message: string
  /** @example "userRegistration" */
  type: I_SMS_VERIFICATION_TYPE_ENUM
  /** @example "sent" */
  status: I_SMS_VERIFICATION_STATUS_ENUM
  code: string
  /** @default 0 */
  attempts: number
  /** @default 3 */
  allowedAttempts: number
  /** @default [] */
  attemptCodes: string[]
  /** @default 60 */
  timeout: number
  error?: string | null
  /** @default false */
  isVerified: boolean
  /** @format date-time */
  sentAt?: string
  /** @format date-time */
  verifiedAt?: string
  /** @default false */
  allowManual: boolean
  userId: string
  investorContractData?: IInvestorContractDataItem[]
}

export interface IUserOnboardingStatus {
  _phoneNumber: boolean
  _email: boolean
  _idCard: boolean
  _investorContract: boolean
  _investmentAllowed: boolean
  _firstInvestment: boolean
}

export interface IOwnerOnboardingStatus {
  _noActiveOrder: boolean
  _orderAndEstateStarted: boolean
  _orderEstateInitialsAdded: boolean
  _orderEstateRoomsInfoAdded: boolean
  _orderEstateRentCalculationAdded: boolean
}

export interface IUser {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  sid: string
  email: string | null
  /** @default false */
  isEmailVerified: boolean
  phoneNumber: string
  /** @default true */
  dataProcessingConsent: boolean
  /** @default false */
  isPhoneNumberVerified: boolean
  /** @default false */
  hasPassword: boolean
  /** @default false */
  isGoogleAccount: boolean
  /** @format date-time */
  registeredAt: string | null
  testing: boolean
  investorProfileId: string | null
  ownerProfileId: string | null
  personalInformationId: string | null
  signaturePrivateKey: string | null
  isInvestor: I_USER_TYPE_ENUM
  /** @default false */
  isOwner: boolean
  _investorProfile?: IInvestorProfile
  _ownerProfile?: IOwnerProfile
  _ownerPensionOrder?: IOwnerPensionOrder
  _personalInformation?: IPersonalInformation
  _smsVerifications?: ISmsVerification[]
  _idCardVerifications?: IIdCardVerification[]
  _audit?: IAudit
  _onboardingStatus: IUserOnboardingStatus
  _ownerOnboardingStatus: IOwnerOnboardingStatus
}

export interface IGetCurrentUserResponse {
  /** success message */
  success: string
  user: IUser
}

export interface IStartPhoneRegistrationInput {
  /** @example "+421901123123" */
  phoneNumber: string
}

export interface IStartPhoneRegistrationResponse {
  /** success message */
  success: string
  smsVerificationId: string
}

export interface IVerifyPhoneRegistrationInput {
  /** SMS verification code */
  code: string
  /** Explicit consent for personal data processing (GDPR) */
  dataProcessingConsent: boolean
  /** JWT token from SMS (alternative to smsVerificationId) */
  smsVerificationId?: string
}

export interface IVerifyPhoneRegistrationResponse {
  /** success message */
  success: string
  /** Access token for immediate login */
  accessToken: string
}

export interface IVerifyPhoneLoginInput {
  /** SMS verification code */
  code: string
  /** JWT token from SMS (alternative to smsVerificationId) */
  smsVerificationId?: string
}

export interface IChangeUserPhoneNumberInput {
  /** @example "+421915123456" */
  phoneNumber: string
}

export interface IChangeUserPhoneNumberResponse {
  /** success message */
  success: string
  user: IUser
}

export interface IGetPersonalInformationResponse {
  /** success message */
  success: string
  personalInformation: IPersonalInformation
}

export interface IUpdatePersonalInformationInput {
  /**
   * The user's first name.
   * @example "John"
   */
  firstName?: string
  /**
   * The user's last name.
   * @example "Doe"
   */
  lastName?: string
  /**
   * The user's current age.
   * @example 75
   */
  age?: number
}

export interface IUpdatePersonalInformationResponse {
  /** success message */
  success: string
  /**
   * The user's first name.
   * @example "John"
   */
  firstName: string
  /**
   * The user's last name.
   * @example "Doe"
   */
  lastName: string
  /**
   * The user's current age.
   * @example 75
   */
  age: number
}

export interface IStartPhoneNumberVerificationInput {
  /** @example "+421901123123" */
  phoneNumber: string
  /**
   * Length of the code to send to the user.
   * @default 4
   * @example 4
   */
  codeLength?: number
  /**
   * Number of seconds until the verification code expires. Must be a multiple of 60 (full minutes).
   * @default 180
   * @example 180
   */
  timeout?: number
}

export interface IStartPhoneNumberVerificationResponse {
  /** success message */
  success: string
  smsVerificationId: string
}

export interface IVerifyPhoneNumberInput {
  code: string
}

export interface IVerifyBySmsCodeCoreResponse {
  /** success message */
  success: string
}

export interface IVerifyPhoneNumberResponse {
  /** success message */
  success: string
  result: IVerifyBySmsCodeCoreResponse
  phoneNumber: string
}

export interface IStartIdCardVerificationInput {
  firstName: string
  lastName: string
  callbackUrl: string
  /** @default false */
  mock?: boolean
}

export interface IStartIdCardVerificationResponse {
  /** success message */
  success: string
  idCardVerification: IIdCardVerification
}

export interface IUserIdCardVerificationConfirmationInput {
  hasIncorrectData: boolean
}

export interface ICreateSupportTicketAppInput {
  /** @example "text" */
  type: 'call' | 'text'
  /** @example "Issue with my account" */
  subject?: string
  /** @example "I am unable to log in to my account." */
  message?: string
}

export interface ICreateSupportTicketResponse {
  /** success message */
  success: string
  supportTicket: object
}

export interface IGetOwnerProfileResponse {
  /** success message */
  success: string
  ownerProfile: IOwnerProfile
}

export interface ICreateOwnerEstateCoreInput {
  /**
   * Type of the estate
   * @example "house"
   */
  type: 'house' | 'flat'
  /**
   * Full address of the estate
   * @example "Example Street 123, Bratislava 81101, Slovakia"
   */
  address: string
  /**
   * LNG
   * @example "10.5"
   */
  x: number
  /**
   * LAT
   * @example "10.5"
   */
  y: number
}

export interface ICreateOwnerEstateResponse {
  /** success message */
  success: string
  ownerEstate: IOwnerEstate
}

export interface IUpdateOwnerEstateDto {
  /** @example 3 */
  level?: number
  /** @example "3A" */
  flatNumber?: string
  /** @example 85 */
  flatArea?: number
  /** @example 85 */
  houseUsableArea?: number
  /** @example 185 */
  landArea?: number
  /** @example 25 */
  numberOfFloors?: number
  /**
   * The current status of the estate.
   * @example "Novostavba"
   */
  status?: I_OWNER_ESTATE_STATUS
  /** @example 4 */
  numberOfRooms?: number
  /** @example 1 */
  numberOfRestrooms?: number
  /** @example 1 */
  numberOfBathrooms?: number
  /** @example 0 */
  numberOfParkingSpots?: number
  /** @example 0 */
  numberOfGarageSpots?: number
  /** @example 300000 */
  apiEstimatedValue?: number
  /** @example 300000 */
  ownerEstimatedValue?: number
}

export interface IUpdateOwnerEstateResponse {
  /** success message */
  success: string
  ownerEstate: IOwnerEstate
}

export interface IGetOwnerEstateResponse {
  /** success message */
  success: string
  ownerEstate: IOwnerEstate
}

export interface IUpdateOwnerPensionOrderDto {
  /** @example 30 */
  payoutYears: number
  /** @example 300000 */
  ownerEstimatedValue: number
}

export interface IUpdateOwnerPensionOrderResponse {
  /** success message */
  success: string
  ownerPensionOrder: IOwnerPensionOrder
}

export interface IGetOwnerPensionOrdersResponse {
  /** success message */
  success: string
  ownerPensionOrders: IOwnerPensionOrder[]
}

export interface IGetOwnerPensionOrderResponse {
  /** success message */
  success: string
  ownerPensionOrder: IOwnerPensionOrder
}

export interface IDeleteOwnerPensionOrderResponse {
  /** success message */
  success: string
  ownerPensionOrder: IOwnerPensionOrder
}

export interface IUploadMultipleFilesResponse {
  /** success message */
  success: string
  files: IUpload[]
}

export type IBuffer = object

export interface IInvestorContractGeneratePdfResponse {
  contentType: string
  filename: string
  content: IBuffer
}

export interface IGetInvestorContractInput {
  id: string
}

export interface IContractsGroup {
  /** @example "investor_main" */
  type: string
  contracts: IContract[]
}

export interface IGetInvestorContractsResponse {
  /** success message */
  success: string
  contracts: IContractsGroup[]
}

export interface IGetInvestorProfileResponse {
  /** success message */
  success: string
  investorProfile: IInvestorProfile
}

export interface IGetInvestorVariableSymbolResponse {
  /** success message */
  success: string
  variableSymbol: string
}

export interface IGetInvestorWalletResponse {
  /** success message */
  success: string
  wallet: IInvestorWallet
}

export interface IInvestorProfileInvestmentOverview {
  accountValue: number
  funds: number
  reservedAmount: number
  investedAmount: number
}

export interface IGetInvestorProfileInvestmentOverviewResponse {
  /** success message */
  success: string
  investmentOverview: IInvestorProfileInvestmentOverview
}

export interface IInvestmentOrderPaymentStatus {
  orderId: string
  /** Whether user has enough funds to pay */
  isPayable: boolean
  /** Whether payment is needed (not paid this month between 1-12 days) */
  needsToPay: boolean
}

export interface IGetInvestmentOrdersPaymentsStatusResponse {
  /** success message */
  success: string
  orders: IInvestmentOrderPaymentStatus[]
  walletFunds: number
}

export interface IInvestmentProduct {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  name: string
  slug: string
  interestPerAnnum: number
  idx: number
  description?: string
  payoutFrequency?: string
  durationInMonths?: number
  bonus?: number
  _audit?: IAudit
}

export interface IGetInvestmentProductResponse {
  /** success message */
  success: string
  investmentProduct: IInvestmentProduct
}

export interface IGetInvestmentProductsResponse {
  /** success message */
  success: string
  investmentProducts: IInvestmentProduct[]
}

export enum I_INVESTMENT_ORDER_STATUS_TYPE_ENUM {
  Created = 'created',
  Pairing = 'pairing',
  Signed = 'signed',
}

export enum I_INVESTMENT_ORDER_AUTOMATIC_REPAYMENT_TYPE_ENUM {
  Card = 'card',
  Funds = 'funds',
}

export interface IInvestmentOrderAutomaticRepayment {
  type: I_INVESTMENT_ORDER_AUTOMATIC_REPAYMENT_TYPE_ENUM | null
  /** @default false */
  enabled: boolean
  /**
   * @minLength 4
   * @maxLength 4
   */
  cardLastFourDigits?: string
}

export interface IInvestmentRepaymentOrder {
  id: string
  roi: number
  roiPercentage: number
  automaticRepayment: IInvestmentOrderAutomaticRepayment
}

export interface IInvestmentRepaymentWarnings {
  _isOverdue: boolean
  _daysUntilDue: number
}

export interface IInvestmentRepayment {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  investmentAmount: number
  /** @format date-time */
  dueDate: string
  isPaid: boolean
  userId: string
  investorProfileId: string
  investmentOrderId: string
  _investmentOrder?: IInvestmentRepaymentOrder
  _warnings: IInvestmentRepaymentWarnings
}

export interface IInvestmentOrder {
  id: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  /** @example "signed" */
  status: I_INVESTMENT_ORDER_STATUS_TYPE_ENUM
  publicId: string
  hasOneTimeInvestment: boolean
  oneTimeInvestmentAmount?: number
  hasMonthlyInvestment: boolean
  monthlyInvestmentAmount?: number
  grossInterestAmount: number
  bonusAmount: number
  totalInvestedAmount: number
  totalReturnedAmount: number
  roi: number
  roiPercentage: number
  /** @format date-time */
  investmentEndDate: string
  riskAcknowledged: boolean
  /** @format date-time */
  riskAcknowledgedAt?: string
  productSnapshot: IInvestmentProductSnapshot
  automaticRepayment: IInvestmentOrderAutomaticRepayment
  userId: string
  investorProfileId: string
  investmentProductId: string
  investorContractId: string
  _investorContract?: IContract
  _investmentRepayments?: IInvestmentRepayment[]
  _user?: IUserBase
}

export interface IGetInvestmentOrdersResponse {
  /** success message */
  success: string
  investmentOrders: IInvestmentOrder[]
}

export interface IGetDueMonthlyInvestmentOrderRepaymentsSumResponse {
  /** success message */
  success: string
  sum: number
}

export interface ICalculateInvestmentOrderRevenueInput {
  hasOneTimeInvestment: boolean
  oneTimeInvestmentAmount: number
  hasMonthlyInvestment: boolean
  monthlyInvestmentAmount?: number
  investmentProductId: string
  durationInMonths: number
}

export interface ICalculateInvestmentOrderRevenueResponse {
  grossInterestAmount: number
  bonusAmount: number
  totalInvestedAmount: number
  totalReturnedAmount: number
  roi: number
  roiPercentage: number
}

export interface IGetInvestmentOrderIdsResponse {
  /** success message */
  success: string
  ids: string[]
}

export interface IGetInvestmentOrderResponse {
  /** success message */
  success: string
  investmentOrder: IInvestmentOrder
}

export interface IInvestorContractDraftInvestmentOrder {
  hasOneTimeInvestment: boolean
  oneTimeInvestmentAmount: number
  hasMonthlyInvestment: boolean
  monthlyInvestmentAmount?: number
  investmentProductId: string
  durationInMonths: number
}

export interface IInvestmentOrderInvestorContractDraftGeneratePdfInput {
  contractType: string
  investmentOrder: IInvestorContractDraftInvestmentOrder
}

export interface IInvestmentOrderInvestorContractDraftGeneratePdfResponse {
  contentType: string
  filename: string
  content: IBuffer
}

export interface IInvestmentOrderInvestorContractsGetInput {
  investmentOrder: IInvestorContractDraftInvestmentOrder
}

export interface IContractDraft {
  type: 'investor_main' | 'investor_investment_order'
  title: string
  content: string
  productSnapshot: IInvestmentProductSnapshot
  investmentProductId: string
  userId: string
}

export interface IInvestmentOrderInvestorContractDraftsGetResponse {
  /** success message */
  success: string
  contractDrafts: IContractDraft[]
}

export interface ICreateInvestmentOrderResponse {
  /** success message */
  success: string
  investmentOrder: IInvestmentOrder
}

export interface IGetInvestorInvestmentCalendarResponse {
  /** success message */
  success: string
  calendar: IInvestmentRepayment[]
}

export interface IGetNextPlannedInvestmentRepaymentResponse {
  /** success message */
  success: string
  investmentRepayment: IInvestmentRepayment | null
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(
      (key) => 'undefined' !== typeof query[key]
    )
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: FormData) =>
      (Array.from(input.keys()) || []).reduce((formData, key) => {
        const property = input.get(key)
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title Bonaship
 * @version 1.0
 * @contact
 *
 * CLIENT API
 *
 * Documentation generated: 23. 09. 2025 14:23:53
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  app = {
    /**
     * No description
     *
     * @tags Investor Transactions
     * @name InvestorTransactionsAppApiControllerGetInvestorTransactionsAndCount
     * @summary Retrieve investor's transactions and count
     * @request GET:/app/investor/investor-transactions
     * @secure
     */
    investorTransactionsAppApiControllerGetInvestorTransactionsAndCount: (
      query?: {
        /** @example 1 */
        page?: number
        /** @example 10 */
        limit?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestorTransactionsAndCountResponse, any>({
        path: `/app/investor/investor-transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investor Transactions
     * @name InvestorTransactionsAppApiControllerCreateInvestment
     * @summary Create investment transaction
     * @request POST:/app/investor/investor-transactions/create
     * @secure
     */
    investorTransactionsAppApiControllerCreateInvestment: (
      data: any,
      params: RequestParams = {}
    ) =>
      this.request<ICreateUserInvestorTransactionResponse, any>({
        path: `/app/investor/investor-transactions/create`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investor Transactions
     * @name InvestorTransactionsAppApiControllerGetInvestorTransactionHistorySnapshots
     * @summary Retrieve investor's balance snapshots over time
     * @request GET:/app/investor/investor-transactions/balance-snapshots
     * @secure
     */
    investorTransactionsAppApiControllerGetInvestorTransactionHistorySnapshots:
      (params: RequestParams = {}) =>
        this.request<IGetInvestorBalanceSnapshotsResponse, any>({
          path: `/app/investor/investor-transactions/balance-snapshots`,
          method: 'GET',
          secure: true,
          format: 'json',
          ...params,
        }),

    /**
     * No description
     *
     * @tags User authentication
     * @name UserAuthAppApiControllerGetCurrentUserInfo
     * @summary Retrieve current user from access token
     * @request GET:/app/user/auth/current
     * @secure
     */
    userAuthAppApiControllerGetCurrentUserInfo: (params: RequestParams = {}) =>
      this.request<IGetCurrentUserResponse, any>({
        path: `/app/user/auth/current`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User authentication
     * @name UserAuthAppApiControllerStartPhoneRegistration
     * @summary Start phone registration process (send SMS verification code)
     * @request POST:/app/user/auth/register-user/start
     */
    userAuthAppApiControllerStartPhoneRegistration: (
      data: IStartPhoneRegistrationInput,
      params: RequestParams = {}
    ) =>
      this.request<IStartPhoneRegistrationResponse, any>({
        path: `/app/user/auth/register-user/start`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User authentication
     * @name UserAuthAppApiControllerVerifyPhoneRegistrationWithJwt
     * @summary Complete registration by verifying SMS code (stateless with JWT)
     * @request POST:/app/user/auth/register-user/verify
     */
    userAuthAppApiControllerVerifyPhoneRegistrationWithJwt: (
      data: IVerifyPhoneRegistrationInput,
      params: RequestParams = {}
    ) =>
      this.request<IVerifyPhoneRegistrationResponse, any>({
        path: `/app/user/auth/register-user/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User authentication
     * @name UserAuthAppApiControllerStartPhoneLogin
     * @summary Start phone login (send SMS code)
     * @request POST:/app/user/auth/login-user/start
     */
    userAuthAppApiControllerStartPhoneLogin: (
      data: IStartPhoneRegistrationInput,
      params: RequestParams = {}
    ) =>
      this.request<IStartPhoneRegistrationResponse, any>({
        path: `/app/user/auth/login-user/start`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User authentication
     * @name UserAuthAppApiControllerVerifyPhoneLogin
     * @summary Login via phone number and SMS verification
     * @request POST:/app/user/auth/login-user/verify
     */
    userAuthAppApiControllerVerifyPhoneLogin: (
      data: IVerifyPhoneLoginInput,
      params: RequestParams = {}
    ) =>
      this.request<IVerifyPhoneRegistrationResponse, any>({
        path: `/app/user/auth/login-user/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserAppApiControllerChangeUnverifiedUserPhoneNumber
     * @summary Change unverified user phone number
     * @request POST:/app/user/change-unverified-phone-number
     * @secure
     */
    userAppApiControllerChangeUnverifiedUserPhoneNumber: (
      data: IChangeUserPhoneNumberInput,
      params: RequestParams = {}
    ) =>
      this.request<IChangeUserPhoneNumberResponse, any>({
        path: `/app/user/change-unverified-phone-number`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User personal information
     * @name PersonalInformationsAppApiControllerGetPersonalInformation
     * @summary Retrieve personal information of user
     * @request GET:/app/user/personal-information
     * @secure
     */
    personalInformationsAppApiControllerGetPersonalInformation: (
      params: RequestParams = {}
    ) =>
      this.request<IGetPersonalInformationResponse, any>({
        path: `/app/user/personal-information`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User personal information
     * @name PersonalInformationsAppApiControllerUpdatePersonalInformation
     * @summary Update personal information of user
     * @request POST:/app/user/personal-information/update
     * @secure
     */
    personalInformationsAppApiControllerUpdatePersonalInformation: (
      data: IUpdatePersonalInformationInput,
      params: RequestParams = {}
    ) =>
      this.request<IUpdatePersonalInformationResponse, any>({
        path: `/app/user/personal-information/update`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User phone number verifications
     * @name PhoneNumberVerificationsAppApiControllerStartPhoneNumberVerification
     * @summary Start verification process for provided phone number
     * @request POST:/app/user/phone-number-verifications/start
     * @secure
     */
    phoneNumberVerificationsAppApiControllerStartPhoneNumberVerification: (
      data: IStartPhoneNumberVerificationInput,
      params: RequestParams = {}
    ) =>
      this.request<IStartPhoneNumberVerificationResponse, any>({
        path: `/app/user/phone-number-verifications/start`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User phone number verifications
     * @name PhoneNumberVerificationsAppApiControllerVerifyPhoneNumber
     * @summary Verify phone number with provided code
     * @request POST:/app/user/phone-number-verifications/verify/{smsVerificationId}
     * @secure
     */
    phoneNumberVerificationsAppApiControllerVerifyPhoneNumber: (
      smsVerificationId: string,
      data: IVerifyPhoneNumberInput,
      params: RequestParams = {}
    ) =>
      this.request<IVerifyPhoneNumberResponse, any>({
        path: `/app/user/phone-number-verifications/verify/${smsVerificationId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User ID Card verifications
     * @name IdCardVerificationsAppApiControllerStartIdCardVerification
     * @summary Start ID card verification process
     * @request POST:/app/user/id-card-verifications/start
     * @secure
     */
    idCardVerificationsAppApiControllerStartIdCardVerification: (
      data: IStartIdCardVerificationInput,
      params: RequestParams = {}
    ) =>
      this.request<IStartIdCardVerificationResponse, any>({
        path: `/app/user/id-card-verifications/start`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User ID Card verifications
     * @name IdCardVerificationsAppApiControllerUserConfirm
     * @summary User confirmation of wether data from ID card is verification
     * @request POST:/app/user/id-card-verifications/user-confirm
     * @secure
     */
    idCardVerificationsAppApiControllerUserConfirm: (
      data: IUserIdCardVerificationConfirmationInput,
      params: RequestParams = {}
    ) =>
      this.request<IStartIdCardVerificationResponse, any>({
        path: `/app/user/id-card-verifications/user-confirm`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Support
     * @name SupportTicketsAppApiControllerCreateSupportTicket
     * @summary Create support ticket for user
     * @request POST:/app/user/support-tickets
     * @secure
     */
    supportTicketsAppApiControllerCreateSupportTicket: (
      data: ICreateSupportTicketAppInput,
      params: RequestParams = {}
    ) =>
      this.request<ICreateSupportTicketResponse, any>({
        path: `/app/user/support-tickets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner authentication
     * @name OwnerAuthAppApiControllerStartPhoneRegistration
     * @summary Start phone registration process (send SMS verification code)
     * @request POST:/app/owner/auth/register-user/start
     */
    ownerAuthAppApiControllerStartPhoneRegistration: (
      data: IStartPhoneRegistrationInput,
      params: RequestParams = {}
    ) =>
      this.request<IStartPhoneRegistrationResponse, any>({
        path: `/app/owner/auth/register-user/start`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner authentication
     * @name OwnerAuthAppApiControllerVerifyPhoneRegistrationWithJwt
     * @summary Complete registration by verifying SMS code (stateless with JWT)
     * @request POST:/app/owner/auth/register-user/verify
     */
    ownerAuthAppApiControllerVerifyPhoneRegistrationWithJwt: (
      data: IVerifyPhoneRegistrationInput,
      params: RequestParams = {}
    ) =>
      this.request<IVerifyPhoneRegistrationResponse, any>({
        path: `/app/owner/auth/register-user/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner authentication
     * @name OwnerAuthAppApiControllerStartPhoneLogin
     * @summary Start phone login (send SMS code)
     * @request POST:/app/owner/auth/login-user/start
     */
    ownerAuthAppApiControllerStartPhoneLogin: (
      data: IStartPhoneRegistrationInput,
      params: RequestParams = {}
    ) =>
      this.request<IStartPhoneRegistrationResponse, any>({
        path: `/app/owner/auth/login-user/start`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner authentication
     * @name OwnerAuthAppApiControllerVerifyPhoneLogin
     * @summary Login via phone number and SMS verification
     * @request POST:/app/owner/auth/login-user/verify
     */
    ownerAuthAppApiControllerVerifyPhoneLogin: (
      data: IVerifyPhoneLoginInput,
      params: RequestParams = {}
    ) =>
      this.request<IVerifyPhoneRegistrationResponse, any>({
        path: `/app/owner/auth/login-user/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's profile
     * @name OwnerProfileAppApiControllerGetOwnerProfile
     * @summary Retrieve user's owner profile
     * @request GET:/app/owner/profile
     * @secure
     */
    ownerProfileAppApiControllerGetOwnerProfile: (params: RequestParams = {}) =>
      this.request<IGetOwnerProfileResponse, any>({
        path: `/app/owner/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner personal information
     * @name PersonalInformationsAppApiControllerUpdatePersonalInformation2
     * @summary Update personal information of user
     * @request POST:/app/owner/personal-information/update
     * @originalName personalInformationsAppApiControllerUpdatePersonalInformation
     * @duplicate
     * @secure
     */
    personalInformationsAppApiControllerUpdatePersonalInformation2: (
      data: IUpdatePersonalInformationInput,
      params: RequestParams = {}
    ) =>
      this.request<IUpdatePersonalInformationResponse, any>({
        path: `/app/owner/personal-information/update`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's estate
     * @name OwnerEstateAppApiControllerCreateOwnerEstate
     * @summary Create new owner estate and pension order
     * @request POST:/app/owner/estate
     * @secure
     */
    ownerEstateAppApiControllerCreateOwnerEstate: (
      data: ICreateOwnerEstateCoreInput,
      params: RequestParams = {}
    ) =>
      this.request<ICreateOwnerEstateResponse, any>({
        path: `/app/owner/estate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's estate
     * @name OwnerEstateAppApiControllerUpdateOwnerEstate
     * @summary Update owner estate
     * @request PATCH:/app/owner/estate/{id}
     * @secure
     */
    ownerEstateAppApiControllerUpdateOwnerEstate: (
      id: string,
      data: IUpdateOwnerEstateDto,
      params: RequestParams = {}
    ) =>
      this.request<IUpdateOwnerEstateResponse, any>({
        path: `/app/owner/estate/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's estate
     * @name OwnerEstateAppApiControllerGetOwnerEstate
     * @summary Retrieve user's owner estate
     * @request GET:/app/owner/estate/{id}
     * @secure
     */
    ownerEstateAppApiControllerGetOwnerEstate: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<IGetOwnerEstateResponse, any>({
        path: `/app/owner/estate/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's pension order
     * @name OwnerPensionOrderAppApiControllerUpdateOwnerPensionOrder
     * @summary Update owner pension order
     * @request PATCH:/app/owner/order-pension/{id}
     * @secure
     */
    ownerPensionOrderAppApiControllerUpdateOwnerPensionOrder: (
      id: string,
      data: IUpdateOwnerPensionOrderDto,
      params: RequestParams = {}
    ) =>
      this.request<IUpdateOwnerPensionOrderResponse, any>({
        path: `/app/owner/order-pension/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's pension order
     * @name OwnerPensionOrderAppApiControllerGetOwnerPensionOrder
     * @summary Retrieve user's owner pension order
     * @request GET:/app/owner/order-pension/{id}
     * @secure
     */
    ownerPensionOrderAppApiControllerGetOwnerPensionOrder: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<IGetOwnerPensionOrderResponse, any>({
        path: `/app/owner/order-pension/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's pension order
     * @name OwnerPensionOrderAppApiControllerSoftDelete
     * @summary Soft delete order
     * @request DELETE:/app/owner/order-pension/{id}
     * @secure
     */
    ownerPensionOrderAppApiControllerSoftDelete: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<IDeleteOwnerPensionOrderResponse, any>({
        path: `/app/owner/order-pension/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's pension order
     * @name OwnerPensionOrderAppApiControllerGetSecondPension
     * @summary Get second pension for frontend
     * @request POST:/app/owner/order-pension/get-second-pension/{id}
     * @secure
     */
    ownerPensionOrderAppApiControllerGetSecondPension: (
      id: string,
      data: IUpdateOwnerPensionOrderDto,
      params: RequestParams = {}
    ) =>
      this.request<IUpdateOwnerPensionOrderResponse, any>({
        path: `/app/owner/order-pension/get-second-pension/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's pension order
     * @name OwnerPensionOrderAppApiControllerGetInvestmentOrders
     * @summary Retrieve pension orders of owner
     * @request GET:/app/owner/order-pension
     * @secure
     */
    ownerPensionOrderAppApiControllerGetInvestmentOrders: (
      params: RequestParams = {}
    ) =>
      this.request<IGetOwnerPensionOrdersResponse, any>({
        path: `/app/owner/order-pension`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's pension order
     * @name OwnerPensionOrderAppApiControllerGetInvestmentOrdersWithDeleted
     * @summary Retrieve deleted pension orders of owner
     * @request GET:/app/owner/order-pension/deleted
     * @secure
     */
    ownerPensionOrderAppApiControllerGetInvestmentOrdersWithDeleted: (
      params: RequestParams = {}
    ) =>
      this.request<IGetOwnerPensionOrdersResponse, any>({
        path: `/app/owner/order-pension/deleted`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's uploads
     * @name UploadsAppApiControllerUploadMultipleFiles
     * @summary Upload multiple files
     * @request POST:/app/owner/uploads
     * @secure
     */
    uploadsAppApiControllerUploadMultipleFiles: (
      data: {
        /** The MongoDB ObjectId of the related estate. */
        estateId?: string
        files?: File[]
      },
      params: RequestParams = {}
    ) =>
      this.request<IUploadMultipleFilesResponse, any>({
        path: `/app/owner/uploads`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Owner's uploads
     * @name UploadsAppApiControllerGetFile
     * @request GET:/app/owner/uploads/{path}
     * @secure
     */
    uploadsAppApiControllerGetFile: (
      path: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/app/owner/uploads/${path}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestorContractsAppApiControllerGenerateSignaleDraftPdf
     * @summary Generates contract pdf for given :id
     * @request POST:/app/investor/contracts/{id}/generate-pdf
     * @secure
     */
    investorContractsAppApiControllerGenerateSignaleDraftPdf: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<IInvestorContractGeneratePdfResponse, any>({
        path: `/app/investor/contracts/${id}/generate-pdf`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestorContractsAppApiControllerGetInvestmentOrder
     * @summary Retrieve single investor contract
     * @request GET:/app/investor/contracts/{id}
     * @secure
     */
    investorContractsAppApiControllerGetInvestmentOrder: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestorContractInput, any>({
        path: `/app/investor/contracts/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestorContractsAppApiControllerGetInvestmentOrders
     * @summary Retrieve investor contracts
     * @request GET:/app/investor/contracts
     * @secure
     */
    investorContractsAppApiControllerGetInvestmentOrders: (
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestorContractsResponse, any>({
        path: `/app/investor/contracts`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investor's profile
     * @name InvestorProfileAppApiControllerGetInvestorProfile
     * @summary Retrieve user's investor profile
     * @request GET:/app/investor/investor-profile
     * @secure
     */
    investorProfileAppApiControllerGetInvestorProfile: (
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestorProfileResponse, any>({
        path: `/app/investor/investor-profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investor's profile
     * @name InvestorProfileAppApiControllerGetInvestorVariableSymbol
     * @summary Retrieve investor's variable symbol
     * @request GET:/app/investor/investor-profile/variable-symbol
     * @secure
     */
    investorProfileAppApiControllerGetInvestorVariableSymbol: (
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestorVariableSymbolResponse, any>({
        path: `/app/investor/investor-profile/variable-symbol`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investor's profile
     * @name InvestorProfileAppApiControllerGetInvestorWallet
     * @summary Retrieve investor's wallet
     * @request GET:/app/investor/investor-profile/wallet
     * @secure
     */
    investorProfileAppApiControllerGetInvestorWallet: (
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestorWalletResponse, any>({
        path: `/app/investor/investor-profile/wallet`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investor's profile
     * @name InvestorProfileAppApiControllerGetInvestorProfileInvestmentOverview
     * @summary Retrieve investor's investment overview
     * @request GET:/app/investor/investor-profile/investment-overview
     * @secure
     */
    investorProfileAppApiControllerGetInvestorProfileInvestmentOverview: (
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestorProfileInvestmentOverviewResponse, any>({
        path: `/app/investor/investor-profile/investment-overview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investor's profile
     * @name InvestorProfileAppApiControllerGetInvestorOrdersPaymentOverview
     * @summary Retrieve investor's orders payment overview
     * @request GET:/app/investor/investor-profile/investment-orders-payment-overview
     * @secure
     */
    investorProfileAppApiControllerGetInvestorOrdersPaymentOverview: (
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestmentOrdersPaymentsStatusResponse, any>({
        path: `/app/investor/investor-profile/investment-orders-payment-overview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment products
     * @name InvestmentProductsAppApiControllerGetInvestmentProduct
     * @summary Retrieve investment product detail
     * @request GET:/app/investor/investment-products/{slug}
     * @secure
     */
    investmentProductsAppApiControllerGetInvestmentProduct: (
      slug: string,
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestmentProductResponse, any>({
        path: `/app/investor/investment-products/${slug}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment products
     * @name InvestmentProductsAppApiControllerGetInvestmentProducts
     * @summary Retrieve investment products
     * @request GET:/app/investor/investment-products
     * @secure
     */
    investmentProductsAppApiControllerGetInvestmentProducts: (
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestmentProductsResponse, any>({
        path: `/app/investor/investment-products`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestmentOrdersAppApiControllerGetInvestmentOrders
     * @summary Retrieve investment orders of investor
     * @request GET:/app/investor/investment-orders
     * @secure
     */
    investmentOrdersAppApiControllerGetInvestmentOrders: (
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestmentOrdersResponse, any>({
        path: `/app/investor/investment-orders`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestmentOrdersAppApiControllerGetMonthlyRepaymentsSum
     * @summary Retrieve due monthly payments sum of all investment orders of investor
     * @request GET:/app/investor/investment-orders/due-monthly-repayments-sum
     * @secure
     */
    investmentOrdersAppApiControllerGetMonthlyRepaymentsSum: (
      params: RequestParams = {}
    ) =>
      this.request<IGetDueMonthlyInvestmentOrderRepaymentsSumResponse, any>({
        path: `/app/investor/investment-orders/due-monthly-repayments-sum`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestmentOrdersAppApiControllerCalculateInvestmentOrderRevenue
     * @summary Recalculate summary of potential investment order.
     * @request POST:/app/investor/investment-orders/calculate-revenue
     * @secure
     */
    investmentOrdersAppApiControllerCalculateInvestmentOrderRevenue: (
      data: ICalculateInvestmentOrderRevenueInput,
      params: RequestParams = {}
    ) =>
      this.request<ICalculateInvestmentOrderRevenueResponse, any>({
        path: `/app/investor/investment-orders/calculate-revenue`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestmentOrdersAppApiControllerGetInvestmentOrderIds
     * @summary Retrieve investment order IDs of investor
     * @request GET:/app/investor/investment-orders/publicIds
     * @secure
     */
    investmentOrdersAppApiControllerGetInvestmentOrderIds: (
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestmentOrderIdsResponse, any>({
        path: `/app/investor/investment-orders/publicIds`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestmentOrdersAppApiControllerGetInvestmentOrder
     * @summary Retrieve investment order detail of investor
     * @request GET:/app/investor/investment-orders/{publicId}
     * @secure
     */
    investmentOrdersAppApiControllerGetInvestmentOrder: (
      publicId: string,
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestmentOrderResponse, any>({
        path: `/app/investor/investment-orders/${publicId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestmentOrdersAppApiControllerGenerateSignaleDraftPdf
     * @summary Retrieves contract draft pdf for given payload.
     * @request POST:/app/investor/investment-orders/contract-drafts/generate-pdf
     * @secure
     */
    investmentOrdersAppApiControllerGenerateSignaleDraftPdf: (
      data: IInvestmentOrderInvestorContractDraftGeneratePdfInput,
      params: RequestParams = {}
    ) =>
      this.request<
        IInvestmentOrderInvestorContractDraftGeneratePdfResponse,
        any
      >({
        path: `/app/investor/investment-orders/contract-drafts/generate-pdf`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestmentOrdersAppApiControllerGetContractDrafts
     * @summary Retrieves contract drafts for given params.
     * @request POST:/app/investor/investment-orders/contract-drafts
     * @secure
     */
    investmentOrdersAppApiControllerGetContractDrafts: (
      data: IInvestmentOrderInvestorContractsGetInput,
      params: RequestParams = {}
    ) =>
      this.request<IInvestmentOrderInvestorContractDraftsGetResponse, any>({
        path: `/app/investor/investment-orders/contract-drafts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investment orders of investor
     * @name InvestmentOrdersAppApiControllerCreateNonCommitalInvestmentOrder
     * @summary Create investment order - non commital
     * @request POST:/app/investor/investment-orders/create/non-commital
     * @secure
     */
    investmentOrdersAppApiControllerCreateNonCommitalInvestmentOrder: (
      data: IInvestorContractInvestmentOrderInput,
      params: RequestParams = {}
    ) =>
      this.request<ICreateInvestmentOrderResponse, any>({
        path: `/app/investor/investment-orders/create/non-commital`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investor's investment calendars
     * @name InvestmentCalendarsAppApiControllerGetInvestorInvestmentCalendar
     * @summary Retrieve investor's investment calendar
     * @request GET:/app/investor/investment-calendar
     * @secure
     */
    investmentCalendarsAppApiControllerGetInvestorInvestmentCalendar: (
      query?: {
        /** Filter by investment order IDs */
        investmentOrderIds?: string[]
        /**
         * Filter repayments with due date greater than or equal to this date
         * @format date-time
         */
        fromDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<IGetInvestorInvestmentCalendarResponse, any>({
        path: `/app/investor/investment-calendar`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Investor's investment calendars
     * @name InvestmentCalendarsAppApiControllerGetNextPlannedInvestmentRepayment
     * @summary Retrieve investor's next planned investment repayment
     * @request GET:/app/investor/investment-calendar/next
     * @secure
     */
    investmentCalendarsAppApiControllerGetNextPlannedInvestmentRepayment: (
      params: RequestParams = {}
    ) =>
      this.request<IGetNextPlannedInvestmentRepaymentResponse, any>({
        path: `/app/investor/investment-calendar/next`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
}
